import lodash from "lodash";
import { useSelector, useDispatch } from "react-redux";

import {
  draftDialogAllSelector,
  //   draftDialogSearchSelector,
} from "store/bailiff/draft/dialog/draft_dialog.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
// =========search & filter ================//
export const useDraftDialogRefine = () => {
  // -------------------------- VAR -----------------------------
  //   const fields = ["name", "description"];
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const data = useSelector(draftDialogAllSelector);
  const sorted = lodash.orderBy(data, "slot", "asc");

  // -------------------------- FUNCTION ------------------------

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return sorted;
};

// const refineData = (data, search, fields) => {
//   let final = data || [];

//   if (search !== "") {
//     final = final?.filter((d) => {
//       const string = combineValueSearch(fields, d);
//       console.log({ string });
//       const lowerName = string?.toLowerCase();
//       const lowerSearch = search?.toLowerCase();
//       const valids = lowerName?.includes(lowerSearch) || false;
//       return valids;
//     });
//   }

//   return final;
// };

// const combineValueSearch = (fields, d) => {
//   let finalStr = "";

//   fields?.forEach((field) => {
//     const value = d[field] || null;
//     if (value) {
//       finalStr += `@${value}`;
//     }
//   });

//   return finalStr;
// };
